import {find, indexOf, size, difference} from 'lodash';
import {asUserId} from "../reducers/asCustomer";

const R_NONE = 0;
const R_VISIBLE = 1;
const R_ENABLED = 2;

export const PARTS = {
  ASSIGN_COMPLEX_LOGIC: 3001,
  ASSIGN_PP_CREATE: 2056,
  ASSIGN_PP_MANAGE: 2055,
  FAB_TOGGLE_BUTTON_BV_2_FACTOR_CONSUMERS: 7009,
  FAB_TOGGLE_BUTTON_BV_2_FACTOR_DASHBOARD: 7010,
  FAB_TOGGLE_BUTTON_BV_ADD_LABOR_CUSTOMER: 7003,
  FAB_TOGGLE_BUTTON_BV_ADD_LABOR_INSTALLER: 7004,
  FAB_TOGGLE_BUTTON_BV_AUTO_CALL_FABRICATOR_FROM_DASHBOARD: 7025,
  FAB_TOGGLE_BUTTON_BV_AUTO_CALL_FABRICATOR_LEAD: 7024,
  FAB_TOGGLE_BUTTON_BV_CHECKOUT: 7002,
  FAB_TOGGLE_BUTTON_BV_CLICK_TO_LEAD_CAPTURE: 7013,
  FAB_TOGGLE_BUTTON_BV_CLICK_TO_LEAD_CAPTURE_DASHBOARD: 7014,
  FAB_TOGGLE_BUTTON_BV_ENABLE_CALENDAR_FOR_SCHEDULING: 7023,
  FAB_TOGGLE_BUTTON_BV_ENABLE_DOCUSIGN: 7026,
  FAB_TOGGLE_BUTTON_BV_ENABLE_GET_QUOTE: 7015,
  FAB_TOGGLE_BUTTON_BV_ENABLE_GET_QUOTE_DASHBOARD: 7016,
  FAB_TOGGLE_BUTTON_BV_ENABLE_SCHEDULING: 7017,
  FAB_TOGGLE_BUTTON_BV_ENABLE_SCHEDULING_DASHBOARD: 7018,
  FAB_TOGGLE_BUTTON_BV_ENABLE_SHARING: 7006,
  FAB_TOGGLE_BUTTON_BV_LEAD_CAPTURE_CONSUMERS: 7011,
  FAB_TOGGLE_BUTTON_BV_LEAD_CAPTURE_DASHBOARD: 7012,
  FAB_TOGGLE_BUTTON_BV_SEPARATE_LABOR_IN_CART: 7005,
  FAB_TOGGLE_BUTTON_BV_SHOW_PRICING: 7001,
  FAB_TOGGLE_BUTTON_BV_SHOW_SMALL_BV_DESIGN_CONSUMERS: 7020,
  FAB_TOGGLE_BUTTON_BV_SHOW_SMALL_BV_DESIGN_DASHBOARD: 7021,
  FAB_TOGGLE_BUTTON_BV_VISUALIZER_ONLY: 7019,
  FAB_TOGGLE_BUTTON_BV_WIZARD_CONSUMERS: 7007,
  FAB_TOGGLE_BUTTON_BV_WIZARD_DASHBOARD: 7008,
  FAB_TOGGLE_BUTTON_BV_YES_NO_CONSULTATION: 7022,
  FAB_TOGGLE_BUTTON_KV_2_FACTOR: 7510,
  FAB_TOGGLE_BUTTON_KV_ADD_LABOR_CUSTOMER: 7505,
  FAB_TOGGLE_BUTTON_KV_ADD_LABOR_INSTALLER: 7512,
  FAB_TOGGLE_BUTTON_KV_CHECKOUT: 7504,
  FAB_TOGGLE_BUTTON_KV_ENABLE_QUOTING: 7501,
  FAB_TOGGLE_BUTTON_KV_ENABLE_SHARING: 7507,
  FAB_TOGGLE_BUTTON_KV_ENABLE_VISUALIZATION: 7502,
  FAB_TOGGLE_BUTTON_KV_LEAD_CAPTURE: 7511,
  FAB_TOGGLE_BUTTON_KV_SEPARATE_LABOR_IN_CART: 7506,
  FAB_TOGGLE_BUTTON_KV_SHOW_PRICING: 7503,
  FAB_TOGGLE_BUTTON_KV_VISUALIZER_ONLY: 7513,
  FAB_TOGGLE_BUTTON_KV_WIZARD_CLIENTS: 7509,
  FAB_TOGGLE_BUTTON_KV_WIZARD_CONSUMERS: 7508,
  FAB_TOGGLE_BUTTON_DEPOSIT: 7514,
  FAB_TOGGLE_ACH_PAYMENTS: 7515,
  FILTERS_ADD_FILTER: 46,
  FILTERS_ASSIGN_ENABLE: 49,
  FILTERS_ASSIGN_FEATURES: 47,
  FILTERS_ASSIGN_STONES: 48,
  FILTERS_EDIT_GROUP: 45,
  FILTERS_EDIT_VALUES: 50,
  FOOTER_ACTIONS: 1,
  HEADER_BUTTON_SWITCH_USER: 6001,
  HEADER_BUTTON_MARKUP_RETAIL: 6005,
  HEADER_BUTTON_MARKUP_COST: 6003,
  HEADER_BUTTON_MARKUP_DISCOUNT: 6004,
  HUB_BUTTON_ACCOUNT_SETTINGS: 30,
  HUB_BUTTON_ADD_BV_QUOTE: 10042,
  HUB_BUTTON_ADD_KV_QUOTE: 10044,
  HUB_BUTTON_DISCOUNTS: 10045,
  HUB_BUTTON_ADD_FP_QUOTE: 10046,
  HUB_BUTTON_ADD_LR_QUOTE: 10047,
  HUB_BUTTON_ADD_QUOTE: 21,
  HUB_BUTTON_ASSIGN_PRICE_PROFILE: 33,
  HUB_BUTTON_CONTACT_US: 37,
  HUB_BUTTON_CUSTOMERS: 22,
  HUB_BUTTON_DASHBOARD: 41,
  HUB_BUTTON_DOCUMENTS: 34,
  HUB_BUTTON_EMAIL_TEMPLATES: 38,
  HUB_BUTTON_EMPLOYEES: 24,
  HUB_BUTTON_FABRICATORS: 23,
  HUB_BUTTON_FEATURE_INCLUSION: 28,
  HUB_BUTTON_FILTERS: 39,
  HUB_BUTTON_INSTALLATIONS: 10043,
  HUB_BUTTON_JOB_BOARD: 20,
  HUB_BUTTON_KITCHEN_VISUALIZER: 31,
  HUB_BUTTON_NEW_CUSTOMER: 25,
  HUB_BUTTON_PROJECT_SCOPE: 27,
  HUB_BUTTON_REPORTS: 35,
  HUB_BUTTON_SITES: 29,
  HUB_BUTTON_STONE_SETUP: 32,
  HUB_BUTTON_STORES: 26,
  HUB_BUTTON_TAXES: 4001,
  HUB_BUTTON_USERS: 36,
  HUB_BUTTON_VISUALIZER_MANAGEMENT: 40,
  INSTALLATION_SETUP_EDIT_ALL: 5005,
  INSTALLATION_SETUP_EDIT_NAME: 5001,
  INSTALLATION_SETUP_EDIT_PRICE: 5004,
  INSTALLATION_SETUP_ENABLE: 5002,
  INSTALLATION_SETUP_UPLOAD_NEW: 5003,
  KV_REMOVE_PRICING: 10,
  QUOTE_MORE_INFO: 3,
  QUOTE_MORE_INFO_ADD_LOG_ENTRY: 4,
  SAVE_QUOTE: 5,
  SCHEDULING_CUSTOMER_PROFILE: 7,
  SCHEDULING_QT_ENABLE: 51,
  STONE_SETUP_EDIT_NAME: 1052,
  STONE_SETUP_EDIT_PRICE: 1055,
  STONE_SETUP_ENABLE: 1053,
  STONE_SETUP_UPLOAD_NEW: 1054,
  VIS_MNGM_BATH_DEF: 43,
  VIS_MNGM_KITCHEN_DEF: 44,
  VIS_MNGM_NEW_LINKS: 42,
  FAB_CREATE_EDIT_GROUP: 8000,
  FAB_CREATE_EDIT_FEATURE: 8001,
  FAB_EDIT_COUNTERTOP: 8002,
  FAB_EDIT_CENTER_ISLAND_COUNTERTOP: 8003,
  FAB_EDIT_BACKSPLASH: 8004,
  JOB_SHOW_PRICE: 9000,
  HUB_BUTTON_KITCHEN_QUOTE_OFFLINE: 10048,
  HUB_BUTTON_BATHROOM_QUOTE_OFFLINE: 10049,
  HUB_BUTTON_AGENT: 10050,
  HUB_BUTTON_WIZARD: 10051,
  HUB_BUTTON_DEALER: 10052,
  PROJECT_SCOPE_FEATURES_SETUP_CONFIGURE: 8005,
  PROJECT_SCOPE_COST: 8006,
  PROJECT_SCOPE_CSV_IMPORT_EXPORT: 8007,
  PROJECT_SCOPE_DELETE_FEATURES: 8008,
  GLOBAL_MARKUP: 8009,
};

const ROLES = {
  SITE_ADMIN: 'site.admin',
  CUSTOMER_ADMIN: 'customer.admin',
  CUSTOMER_USER: 'customer.user',
  CLIENT_USER: 'client.user',
  FABRICATOR_USER: 'fabricator.user',
  FABRICATOR_ADMIN: 'fabricator.admin',
  FABRICATOR_MASTER: 'fabricator.master'
};

let instanceCount = 0;

let hasAnyRoles = false;

class AccessRights {
  constructor() {
    instanceCount++;
    if (instanceCount > 1)
      alert("Cannot create multiple instances of 'AccessRights' object.");

    this.currentRoles = [];
    this.auth = null; // reference to redux state -> auth reducer, set bellow in the .get method
    this.asCustomer = null; // reference to redux state -> asCustomer reducer, set bellow in the .get method
  }

  checkRights(part, useAsUser = true) {
    if (!this.auth || !this.auth.protectedAreas) {
      return {visible: false, enabled: false};
    }
    if (this.isSiteAdmin()) {
      return {visible: true, enabled: true};
    }

    const asCustomerProtectedAreas = useAsUser ? this.asCustomer && this.asCustomer.data && this.asCustomer.data.protectedAreas : null;
    const pa = find(asCustomerProtectedAreas || this.auth.protectedAreas, {'protectedAreaId': part});
    return pa
      ? {visible: pa.accessRights >= R_VISIBLE, enabled: pa.accessRights >= R_ENABLED}
      : {visible: false, enabled: false};
  }

  checkRightsAdminRestricted(part) {
    if (!this.auth || !this.auth.protectedAreas) {
      return {visible: false, enabled: false};
    }

    const pa = find(this.auth.protectedAreas, {'protectedAreaId': part});
    return pa
      ? {visible: pa.accessRights >= R_VISIBLE, enabled: pa.accessRights >= R_ENABLED}
      : {visible: false, enabled: false};
  }

  /**
   * Checks whether a part is visible for current user
   * @param part
   * @param useAsUser [Optional]
   * @returns {boolean}
   */
  v(part, useAsUser) {
    return this.checkRights(part, useAsUser).visible;
  }

  /**
   * Checks whether a part is enabled for current user
   * @param part
   * @param useAsUser [Optional]
   * @return {boolean|*}
   */
  e(part, useAsUser) {
    return this.checkRights(part, useAsUser).enabled;
  }

  /**
   * Checked whether a part is disabled for current user
   * @param part
   * @param useAsUser [Optional]
   * @returns {boolean}
   */
  d(part, useAsUser) {
    return !this.e(part, useAsUser);
  }

  /**
   * Special check for permissions on JobBoard page
   * @param part
   * @param permissions object {fabId, [protectedAreas]}
   * @param fabId
   */
  vJB(part, permissions, fabId) {
    if (!permissions)
      return true; // this only happens for the super.admin

    const asCustomerProtectedAreas = this.asCustomer && this.asCustomer.data && this.asCustomer.data.protectedAreas;
    const protectedAreas = asCustomerProtectedAreas || permissions[fabId];
    if (!protectedAreas) return true;
    const pa = find(protectedAreas, {protectedAreaId: part});
    if (!pa) return true;
    return pa.accessRights >= R_VISIBLE;
  }

  setCurrentRoles(roles) {
    this.currentRoles = [].concat(roles);
    hasAnyRoles = indexOf(this.currentRoles, ROLES.SITE_ADMIN) !== -1 ||
      indexOf(this.currentRoles, ROLES.CUSTOMER_ADMIN) !== -1 ||
      indexOf(this.currentRoles, ROLES.CUSTOMER_USER) !== -1 ||
      indexOf(this.currentRoles, ROLES.CLIENT_USER) !== -1 ||
      indexOf(this.currentRoles, ROLES.FABRICATOR_USER) !== -1 ||
      indexOf(this.currentRoles, ROLES.FABRICATOR_ADMIN) !== -1 ||
      indexOf(this.currentRoles, ROLES.FABRICATOR_MASTER) !== -1;
    //this.dump();
  }

  roles() {
    const asCustomerRoles = this.asCustomer && this.asCustomer.data && this.asCustomer.data.roles;
    return asCustomerRoles || this.currentRoles;
  }

  isClient() {
    return !hasAnyRoles || indexOf(this.roles(), ROLES.CLIENT_USER) !== -1;
  }

  isClientUser() {
    return this.isClient();
  }

  isFabUser() {
    return indexOf(this.roles(), ROLES.FABRICATOR_USER) !== -1;
  }

  isFabAdmin() {
    return indexOf(this.roles(), ROLES.FABRICATOR_ADMIN) !== -1 ||
      this.isFabMaster();
  }

  isFabMaster() {
    return indexOf(this.roles(), ROLES.FABRICATOR_MASTER) !== -1;
  }

  isSiteAdmin(ignoreAsUser) {
    return indexOf(ignoreAsUser ? this.currentRoles : this.roles(), ROLES.SITE_ADMIN) !== -1;
  }

  canSwitchUsers() {
    // return this.isSiteAdmin(true); //this.isFabAdmin();// || this.isFabMaster() || this.isSiteAdmin();
    return this.isSiteAdmin(true) || this.e(PARTS.HEADER_BUTTON_SWITCH_USER, false);
  }

  canEnableCustomer() {
    return !this.isClientUser();
  }

  /**
   * Checks whether the currently logged in user is the same as the given ID
   * @param {int} userId
   * @param {boolean} ignoreAsUser
   */
  isMe(userId, ignoreAsUser = true) {
    return (ignoreAsUser ? this.auth.userId : (asUserId(this.asCustomer) || this.auth.userId)) === +userId;
  }

  // various rights related to employee page and when editing an employee
  /**
   *
   * @param e {Object}
   */
  employee = (e) => {
    const {auth, asCustomer} = this;
    let userId = auth.userId;
    let roles = auth.roles;
    if (asCustomer.activeEntity) {
      userId = asCustomer.activeEntity.id;
      roles = asCustomer.activeEntity.roles;
    }

    let isEmployeeFabricatorMaster = e.masterProfile ? e.masterProfile.isMaster : e.isFabricatorMaster;

    return {
      canSeePermissionsButton: () => {
        return this.isSiteAdmin(); // TODO: Make proper logic for permissions button

        if (!e || !e.id)
          return false;

        if (!size(roles))
          return false;

        if (userId === e.id)
          return false;

        switch (roles[0].toLowerCase()) {
          case 'fabricator.admin': // Licensed Admin, only employees
            return !isEmployeeFabricatorMaster && !e.isLicensedAdmin;
          case 'fabricator.user': // Employee
            return false;
          case 'fabricator.master': // Master Fabricator
            return !isEmployeeFabricatorMaster;
        }

        return true;
      },
      canSeeAddFabricatorButton: () => this.isSiteAdmin(false) || this.isFabAdmin() || this.isFabMaster(),
      isLicensedAdminCheckBoxDisabled: () => {
        if (!e || !e.id)
          return true;
        if (userId === e.id)
          return true;
        if (!size(roles))
          return true;
      },
      isMasterFabricatorCheckBoxDisabled: () => {
        return !this.isSiteAdmin(false);
      },
      isEnabledCheckBoxDisabled: () => {
        if (this.isSiteAdmin(false))
          return false;

        if (!e || !e.id || !size(roles))
          return true;

        if (userId === e.id)
          return true;

        switch (roles[0].toLowerCase()) {
          case 'fabricator.admin': // Licensed Admin, only employees
            return isEmployeeFabricatorMaster || e.isLicensedAdmin;
          case 'fabricator.user': // Employee
            return false; // no one
          case 'fabricator.master': // Master Fabricator
            return isEmployeeFabricatorMaster; // anybody not master fabricator
        }

        return false;
      },
      canSeeEditButton: () => {
        if (!e || !e.id || !size(roles))
          return false;

        if (userId === e.id || this.isSiteAdmin(false))
          return true;

        switch (roles[0].toLowerCase()) {
          case 'fabricator.admin': // Licensed Admin, only employees
            return !(isEmployeeFabricatorMaster || e.isLicensedAdmin);
          case 'fabricator.user': // Employee
            return false; // no one
          case 'fabricator.master': // Master Fabricator
            return !isEmployeeFabricatorMaster; // anybody not master fabricator
        }

        return false;
      }
    }
  }

  fabricator = e => {
    return {
      canSeePermissionsButton: () => false,
      canSeeAddFabricatorButton: () => false,
      isLicensedAdminCheckBoxDisabled: () => false,
      isEnabledCheckBoxDisabled: () => !this.isSiteAdmin(false)
    }
  }

  customer = e => {
    const {auth, asCustomer} = this;
    let userId = auth.userId;
    let roles = auth.roles;
    if (asCustomer.activeEntity) {
      userId = asCustomer.activeEntity.id;
      roles = asCustomer.activeEntity.roles;
    }

    return {
      canSeePermissionsButton: () => false,
      canSeeAddFabricatorButton: () => false,
      isLicensedAdminCheckBoxDisabled: () => false,
      isEnabledCheckBoxDisabled: () => {
        if (!e || !e.id)
          return true;
        if (userId === e.id)
          return true;
        return this.isClientUser();
      }
    }
  }

  /**
   * Validate the new Authentication information with the old one
   * @param oldAuth
   * @param newAuth
   * @returns {boolean}
   */
  static validateNewAuth(oldAuth, newAuth) {
    if (size(difference(oldAuth.roles, newAuth.roles))) {
      return false;
    }

    if (oldAuth.userId !== newAuth.userId || oldAuth.customerId !== newAuth.customerId
      || oldAuth.fabricatorId !== newAuth.fabricatorId) {
      return false;
    }

    return true;
  }

  dump() {
    console.log(this.currentRoles);
  }
}

AccessRights.instance = new AccessRights();
AccessRights.displayName = 'Access Rights';

/**
 * Returns the singleton instance of the AccessRights object
 * @state {object} Redux state
 * @returns {AccessRights}
 */
AccessRights.get = (state) => {
  let instance = AccessRights.instance;
  instance.auth = state ? state.auth : null;
  instance.asCustomer = state ? state.asCustomer : null;
  return instance;
};

export {AccessRights};
